export const columns = [
  {
    name: 'locationName',
    displayName: 'Location Name',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'locationShortCode',
    displayName: 'Shortcode',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'locationId',
    displayName: 'Location ID',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'locationType',
    displayName: 'Location Type',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'parent',
    displayName: 'Parent',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'children',
    displayName: 'Children',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'status',
    displayName: 'Status',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'actions',
    displayName: 'Actions',
    isFilterable: false,
    isSortable: false,
    isVisible: true,
    type: 'override',
  }
];
